import { render, staticRenderFns } from "./SupervisorQuerylogsDashboard.vue?vue&type=template&id=b8ac1e20&"
import script from "./SupervisorQuerylogsDashboard.vue?vue&type=script&lang=js&"
export * from "./SupervisorQuerylogsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports